import { Box, Image, Text } from "@chakra-ui/react";
import React, { useCallback, useEffect, useState } from "react";
import {
  checkRules,
  extractChatId,
  isEmptyOrNull,
  isNotEmptyOrNull } from
"../../../utils/common-utils";
import play from "../../../assets/factualPlay.svg";
import Assistant from "../../../components/molecules/ai-tutor/Assistant/Assistant";
import AssistantImg from "../../../assets/ai-tutor/assistant.svg";
import ChatView from "../../../components/molecules/ai-tutor/ChatView/ChatView";
// import FactualCard from "../../../components/molecules/factual/FactualCard";
import pkg from "@inrscr/coschool-ui-components";
import LiveStreaming from "../../../components/molecules/ai-tutor/ChatView/LiveStreaming";
import { QuestionsLayout } from "../../../components/molecules/questionLayouts/QuestionsLayout";
import { commonProps } from "../../review/reviewUtils";
import { learningModes, taskTypes } from "../../../utils/LearningPathUtils";
import { questionTypes } from "../../../utils/LearningPathUtils";
import styles from "../../../components/molecules/ai-tutor/Assistant/assistant.module.css";
import { usePractice } from "../../../context/PracticeContext";
import { useRoot } from "../../../context/RootContext";
import { useTutor } from "../../../context/AiTutorContext";
import { PracticeLayoutStyles } from "./PracticeLayoutStyles";
import ProgressView from "../../../components/molecules/progressView/progressView";
import { StorageService } from "../../../utils/StorageUtils";
import TutorReviewMode from "../../review/TutorReviewMode";
import useStateRef from "react-usestateref";
import Lottie from "react-lottie-player";
import MultiProgressLoading from "../../../assets/lotties/MultiProgressLoading.json";
import { getChatInfoByIds } from "../../../network/TutorApiService";

export default function PracticeLayout({
  onChange,
  displaySubmit,
  isAnswerSubmitted,
  handleDisplayQuestionsForFactual,
  overAllQuestionResult,
  subjectMasterUuid,
  topicMasterUuid,
  journeyId,
  isDiscussFlow,
  saveEvent,
  authToken
}) {
  const {
    displayedQues,
    chatHistory,
    chatQuery,
    streamingText,
    currentQuesIndex,
    assistantRefImages,
    displayQuestionsWithoutFactualVideo,
    isConcluded,
    learningStepData,
    setChatHistory,
    setIsAnswerSubmitted,
    isConvCompleted,
    setShowHintBtn,
    setChatIndex,
    updateShowConcludeBtn
  } = usePractice();
  const {
    loader,
    isFactual,
    setIsFactual,
    setIsPlayerOpen,
    // learningStepData,
    setSelectedFactualIndex
  } = useTutor();
  const {
    selectedIndex,
    isReviewScreen,
    isStudentAppMapping,
    isStandalone,
    taskType,
    reviewQuestionsData,
    executionHistoryLoaded
  } = useRoot();
  const { FactualCard } = pkg;
  const [isFirstTime, setIsFirstTime, isFirstTimeRef] = useStateRef(true);
  // const { ProgressView } = pkg;
  const [userDetails, setUserDetails] = useState({});
  const [backUpObject, setBackUpObject] = useState({});
  const [
  displayExecutionFlow,
  setDisplayExecutionFlow,
  displayExecutionFlowRef] =
  useStateRef(false);
  const onPlay = () => {
    setIsFactual(true);
    setIsPlayerOpen(true);
  };

  useEffect(() => {
    setUserDetails({});
    let details = StorageService.getItem("user_additional_details");
    details = typeof details === "object" ? details : JSON.parse(details);
    if (details) {
      setUserDetails(details);
    }
    const storedBackUp = StorageService.getItem("backUpObject");
    if (isNotEmptyOrNull(storedBackUp)) {
      setBackUpObject(storedBackUp);
    }
  }, []);

  useEffect(() => {
    setIsFactual(isFactual);
  }, [isFactual]);

  useEffect(() => {
    let showContent = isDiscussFlow ? true : displayExecutionFlowRef.current;
    showContent = isStandalone ? true : showContent;
    if (showContent) {
      setIsFirstTime(false);
      let userAnswer = displayedQues?.[displayedQues?.length - 1]?.userAnswer;
      getChatHistoryForCurrentExeQues(userAnswer);
    }
  }, [displayExecutionFlowRef.current]);

  const getChatHistoryForCurrentExeQues = async (userAnswer) => {
    let chatId = await extractChatId(userAnswer);
    if (isNotEmptyOrNull(chatId)) {
      let chatData = await getChatInfoByIds([chatId]);
      chatData = chatData?.[chatId]?.history;
      let chatHist = { ...(chatHistory || {}) };
      chatHist[currentQuesIndex] = chatData;
      setChatHistory(chatHist);
      setChatIndex((chatHist?.[currentQuesIndex]?.length || 0) / 2);
      setIsAnswerSubmitted(true);
      const enableHintBtn =
      chatData?.length / 2 >=
      parseInt(window?.ENV?.SHOW_HINT_BUTTON_AFTER || 1);
      if (enableHintBtn && isConvCompleted == false) {
        setShowHintBtn(true);
      }
      updateShowConcludeBtn();
    }
  };

  const onAnswerChanged = useCallback(
    (changedAnswer, currentQuestion, hashedIndexAnswer, selectedIndex) => {
      onChange && onChange();
      // setSaveAnswers(changedAnswer);
      displaySubmit(
        isNotEmptyOrNull(currentQuestion?.answers_index_hashed_keys) ?
        currentQuestion?.answers_index_hashed_keys :
        isNotEmptyOrNull(currentQuestion?.answers_key) ?
        currentQuestion?.answers_key :
        currentQuestion?.answers_layout,
        changedAnswer,
        hashedIndexAnswer,
        selectedIndex
      );
    },
    []
  );

  useEffect(() => {
    if (
    isNotEmptyOrNull(
      displayedQues?.[currentQuesIndex]?.learning_mode?.toLowerCase() ===
      learningModes.FactualBasket
    ) &&
    !isNotEmptyOrNull(displayedQues?.[currentQuesIndex]?.content) &&
    isNotEmptyOrNull(
      displayedQues?.[currentQuesIndex]?.factual_rule_set?.[0]?.questions
    ))
    {
      handleDisplayQuestionsForFactual();
    }
  }, [displayedQues, currentQuesIndex]);

  const historyLoaded = () => {
    setDisplayExecutionFlow(true);
  };

  const hasSpecificQuestionTypes = (questions) => {
    if (!Array.isArray(questions)) {
      return false;
    }
    return questions?.some(
      (question) =>
      question.questionObject?.question_type === questionTypes.long_answer ||
      question.questionObject?.question_type === questionTypes.short_answer ||
      question.questionObject?.question_type ===
      questionTypes.very_short_answer
    );
  };

  const renderQuestion = useCallback(() => {
    let showLoader =
    (isDiscussFlow ? false : !displayExecutionFlowRef.current) &&
    isNotEmptyOrNull(displayedQues);
    showLoader = isStandalone ? false : showLoader;
    let showContent = isDiscussFlow ? true : displayExecutionFlowRef.current;
    showContent = isStandalone ? true : showContent;
    return (
      <React.Fragment>
        {showContent && isNotEmptyOrNull(displayedQues) && !isStandalone &&
        <Assistant
          data-testid="emotional-message-assistant"
          emotionalMessageCode={
          taskType === "assessment" ||
          backUpObject?.taskType === "assessment" ?
          1 :
          taskType === "guidedPractise" ||
          backUpObject?.taskType === "guidedPractise" ?
          5 :
          taskType === "learnSubtopic" ||
          backUpObject?.taskType === "learnSubtopic" ?
          9 :
          5
          }
          isEmotionalScript={true} />

        }
        {isNotEmptyOrNull(journeyId) && !isStandalone &&
        <div id="tutor-review-container" className={styles.hideScrollbar}>
            <TutorReviewMode
            journeyId={journeyId}
            subjectMasterUuid={subjectMasterUuid}
            topicMasterUuid={topicMasterUuid}
            isExecutionHistory={true}
            isHistoryLoaded={historyLoaded} />

          </div>
        }
        {showLoader &&
        <Box
          id="loading-container"
          height="10px"
          width="100%"
          padding="10px"
          backgroundColor="transparent"
          justifyContent="center"
          alignItems="center"
          display={"flex"}>

            <Lottie
            id="loading-animation"
            loop
            animationData={MultiProgressLoading}
            play
            style={{
              width: "100px",
              height: "100px"
            }} />

          </Box>
        }
        {showContent &&
        displayedQues.map((question, index) => {
          let isDontAllow =
          index !== currentQuesIndex &&
          isNotEmptyOrNull(
            displayedQues?.[index]?.learning_mode?.toLowerCase()
          ) &&
          displayedQues?.[index]?.learning_mode?.toLowerCase() !==
          learningModes.FactualBasket;
          const descQuestionTypes = [
          questionTypes.short_answer,
          questionTypes.long_answer,
          questionTypes.very_short_answer];

          const isDescQues = descQuestionTypes?.includes(
            question?.question_type
          );

          // Check if this is the first SCQ question in the sequence
          const isFirstMultipleQuestion =
          displayedQues.findIndex(
            (q) =>
            taskType === taskTypes.assessment &&
            q?.question_type === questionTypes.scq
          ) === index;
          // Check if this is the first descriptive question in the sequence
          const isFirstDescQuestion =
          displayedQues.findIndex(
            (q) =>
            taskType === taskTypes.assessment &&
            descQuestionTypes.includes(q?.question_type)
          ) === index;

          return (
            <React.Fragment key={index}>
                {isNotEmptyOrNull(
                question?.dialog_entry_script?.content?.[0]?.text
              ) &&
              <Assistant
                data-testid={`dialog-entry-assistant-${index}`}
                text={
                question?.dialog_entry_script?.content?.[0]?.text ?
                `${question?.dialog_entry_script?.content?.[0]?.text.
                replace(
                  "@@studentName",
                  `${userDetails.firstName}`
                ).
                replace(/@@linebreak/g, `\n`)}` :
                ""
                }
                isDialogScript={true}
                isCopy={false} />

              }
                {isNotEmptyOrNull(
                question?.learning_mode?.toLowerCase() ===
                learningModes.FactualBasket
              ) && isNotEmptyOrNull(question?.contents) ?
              <div id={`factual-basket-container-${index}`}>
                    {isNotEmptyOrNull(question?.contents) &&
                <div id={`factual-content-wrapper-${index}`}>
                        {!isNotEmptyOrNull(
                    question?.dialog_entry_script?.content?.[0]?.text
                  ) &&
                  <img
                    id={`assistant-image-${index}`}
                    className={styles["assistant-img"]}
                    src={AssistantImg}
                    alt="assistant" />

                  }
                        <Box
                    id={`factual-card-container-${index}`}
                    style={{
                      marginTop: !isNotEmptyOrNull(
                        question?.dialog_entry_script?.content?.[0]?.text
                      ) ?
                      "-30px" :
                      "0px"
                    }}
                    onClick={() => {
                      setSelectedFactualIndex(index);
                    }}>

                          <FactualCard
                      authToken={authToken}
                      icons={{ play: play }}
                      saveEvent={saveEvent}
                      index={index}
                      question={question}
                      displayedQues={displayedQues}
                      currentQuestionIndex={currentQuesIndex} />

                        </Box>
                      </div>
                }
                  </div> :

              <div id={`question-container-${index}`}>
                    {/* Show header for first SCQ or first descriptive question */}
                    {(isFirstMultipleQuestion || isFirstDescQuestion) &&
                !isDiscussFlow &&
                <div id={`question-type-header-${index}`}>
                          <Text
                    id={`question-type-text-${index}`}
                    className={styles["question-type-style"]}>

                            {isFirstMultipleQuestion ?
                    "Single choice questions" :
                    "Descriptive answer questions"}
                          </Text>
                          <Box
                    id={`question-type-divider-primary-${index}`}
                    w={"35%"}
                    backgroundColor="#130159"
                    h={"6px"}
                    marginTop={"25px"}>
                  </Box>
                          <Box
                    id={`question-type-divider-secondary-${index}`}
                    w={"100%"}
                    backgroundColor="#13015966"
                    marginBottom={"25px"}
                    h={"1px"}>
                  </Box>
                        </div>
                }
                    <div
                  className={styles["prevent-select"]}
                  id={`question-layout-practicelayout-${index}`}>

                      <QuestionsLayout
                    data-testid={`questions-layout-${index}`}
                    questionObject={question}
                    userAnswer={question?.userAnswer}
                    onAnswerChanged={onAnswerChanged}
                    isDontAllow={isDontAllow}
                    allowToCopy={false}
                    isFactualBasket={isFactual}
                    taskType={taskType}
                    isAnswerSubmitted={isAnswerSubmitted}
                    displayedQues={displayedQues} />

                    </div>
                    <div
                  style={{ pointerEvents: "auto" }}
                  id={`chatview-practicelayout-${index}`}>

                      {chatHistory?.[index]?.length > 0 &&
                  <ChatView
                    data-testid={`chat-view-${index}`}
                    history={chatHistory?.[index]}
                    assistantRefImages={assistantRefImages?.[index]}
                    isDisplayUserQuery={
                    selectedIndex === 3 ||
                    selectedIndex === 4 ||
                    taskType === "guidedPractise" ?
                    false :
                    true
                    }
                    isDescAnsQues={isDescQues} />

                  }
                    </div>
                  </div>
              }
                <div
                id={`exit-script-container-${index}`}
                style={{ marginBottom: "40px" }}>

                  {question?.exitScript &&
                <Assistant
                  data-testid={`exit-script-assistant-${index}`}
                  text={`${question?.text?.
                  replace("@@studentName", `${userDetails.firstName}`).
                  replace(/@@linebreak/g, `\n`)}`}
                  isCopy={false}
                  isDialogScript={true} />

                }
                </div>
              </React.Fragment>);

        })}
      </React.Fragment>);

  }, [displayedQues, chatHistory, isFactual, executionHistoryLoaded]);

  return (
    <Box
      id="practice-layout-main-container"
      sx={PracticeLayoutStyles()?.mainContainer}>

      {(isNotEmptyOrNull(learningStepData) ||
      isNotEmptyOrNull(displayedQues)) &&
      !isReviewScreen &&
      <Box
        id="progress-view-container"
        mb={
        isStandalone && !isStudentAppMapping ?
        0 :
        isNotEmptyOrNull(displayedQues) ?
        { base: "10%", md: "8%", lg: "6%", xl: "4%" } :
        0
        }>

            <ProgressView
          data-testid="progress-view"
          displayedQues={displayedQues} />

          </Box>
      }
      <Box
        id="practice-layout-sub-container"
        sx={
        isStandalone ?
        PracticeLayoutStyles()?.standaloneSubContainer :
        PracticeLayoutStyles()?.subContainer
        }>

        <div id="questions-render-container">{renderQuestion()}</div>

        <LiveStreaming
          data-testid="livestreaming-practicelayout"
          showUserQuery={
          selectedIndex === 3 ||
          selectedIndex === 4 ||
          taskType === "guidedPractise" ?
          chatHistory?.[currentQuesIndex]?.length > 0 :
          true
          }
          query={chatQuery}
          answer={streamingText}
          loader={loader}
          hideVin={true}
          isConclude={isConcluded} />

      </Box>
    </Box>);

}